import classNames from 'classnames'
import i18next from 'i18next'

import { Link, useLocation, useParams } from 'react-router'
import { AboutIcon, EventsIcon, TrackingIcon } from './Icon'

export type MenuItemType = 'shipmentEvents' | 'aboutShipment' | 'shipmentTracking'

interface MenuItemProps {
  menuItemType: MenuItemType
  isActive: boolean
  className?: string
}

const MenuItem = ({ menuItemType, isActive = false }: MenuItemProps) => {
  const { trackingId } = useParams<{ trackingId: string }>()
  const { search } = useLocation()

  let link = `/${trackingId}/info`
  let Icon = null

  if (menuItemType === 'shipmentEvents') {
    Icon = EventsIcon
    link = `/${trackingId}/events`
  } else if (menuItemType === 'aboutShipment') {
    Icon = AboutIcon
    link = `/${trackingId}/info`
  } else if (menuItemType === 'shipmentTracking') {
    Icon = TrackingIcon
    link = `/${trackingId}/`
  }

  return (
    <Link
      to={link + search}
      aria-current={isActive ? 'page' : undefined}
      className={classNames(isActive ? 'active text-primary-500-a11y' : '', 'flex items-center flex-col')}
    >
      {Icon && <Icon />}
      <span className="link-text">{i18next.t(`menu.${menuItemType}`)}</span>
    </Link>
  )
}

export default MenuItem
